import type { ReactNode } from 'react';

export const symbol_mobile_code: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-100v-760 760Zm240-629q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9ZM260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v150q18 3 30 16.95 12 13.96 12 31.63V-587q0 19-12 33t-30 17v128q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-451H260v760h145q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q417.75-40 405-40H260Zm320-150 66 66q9 9 9 21.16t-8.61 21Q637-73 624.9-73q-12.1 0-20.9-9l-88-87q-9-9-9-21t9-21l88-87q9-8 21-8.5t21.39 8.5q8.61 9 8.61 21t-9 21l-66 66Zm254 0-66-66q-9-9-9-21.16t8.61-21Q777-307 789.1-307q12.1 0 20.9 9l88 87q9 9 9 21t-9 21l-88 87q-9 8-21 8.5T767.61-82Q759-91 759-103t9-21l66-66Z"
		/>
	</svg>
);
